'use client';

import Image from 'next/image';
import type React from 'react';
import { SYNGENTA_CNPJ, SYNGENTA_LEGAL_NAME } from '@/config/company';
import { translate } from '@/lib/i18n/translate';
import styles from './page.module.css';

export default function AuthLayout({
  children,
}: Readonly<{
  children: React.ReactNode;
}>) {
  return (
    <div className={styles.page}>
      <div className={styles.page__background}>
        <Image
          src="/assets/img/login-avatar.png"
          alt="logo"
          className={styles.page__avatar}
          width={526}
          height={825}
          quality={90}
          priority
        />
      </div>
      <div className={styles.page__content}>
        {children}
        <div className={styles.page__footer}>
          <p>
            {SYNGENTA_LEGAL_NAME} •{' '}
            {translate('PAGES.AUTH.LOGIN.SYNGENTA_CNPJ')}
            {SYNGENTA_CNPJ}
          </p>
        </div>
      </div>
      <Image
        src="/assets/img/layout_bg.svg"
        width={568}
        height={622}
        alt="watermark"
        className={styles.page__watermark}
      />
    </div>
  );
}
